import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class TouGuard implements CanActivate {

  constructor(private router: Router, private authService: AuthService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const isTouAccepted = localStorage.getItem('isTouAccepted') === 'true';

    let tokenStr: any = sessionStorage.getItem('jwttoken')!;
    if (isTouAccepted || !tokenStr) {
      return true;
    } else {
      this.authService.logoutAndReset();
      return false;
    }
  }
}
